import { getWindowDimensions } from './general'


export const initialState = {
    url: ['127.0.0.1', '0.0.0.0', 'localhost'].includes(window.location.hostname) ? 'http://127.0.0.1:3333' : 'https://api.meridiansafe.org',
    site: localStorage.getItem('site') ? JSON.parse(localStorage.getItem('site')) : {
        name: 'Meridian Safe Bank',
        domain: 'meridiansafe.org',
        address: '8 Scarcroft Road PORTINSCALE CA12 0XQ',
        country: 'United Kingdom',
        country_code: 'GBR'
    },
    activeTheme: localStorage.getItem('theme') || "light",
    // banner: {
    //     message: 'This is a dummy text in place of banner',
    //     exp: '2025-02-6'
    // },
    banner: null,
    windowDimensions: getWindowDimensions(),
    customer: sessionStorage.getItem('customer') ? JSON.parse(sessionStorage.getItem('customer')) : null,
    activities: [],
    processing: false,
    processingDash: false,
    showHeader: true,
    processPercent: 0,
    bearerToken: '',
    notify: null,
    flashNote: null,
    activeMenu: localStorage.getItem('home_page') || 'dashboard',
    showAside: false,
    settings: null,
    showBalance: localStorage.getItem('show_balance') && localStorage.getItem('show_balance') === 'false' ? false : true
}

const reducer = (state, action)=>{
    const allowed_themes = ['dark', 'light']

    switch (action.type) {
        case 'SET_THEME':
            if (allowed_themes.includes(action.theme)) {
                localStorage.setItem('theme', action.theme)
                return {
                    ...state,
                    activeTheme: action.theme
                }
            }else {
                return state;
            }
        case 'SET_SITE':
            return {
                ...state,
                site: action.data
            }
        case 'SET_CUSTOMER':
            if (sessionStorage.getItem('customer')) sessionStorage.removeItem('customer')
            sessionStorage.setItem('customer', JSON.stringify(action.data))
            return {
                ...state,
                customer: action.data
            }
        case 'CLEAR_CUSTOMER':
            return {
                ...state,
                customer: null
            }
        case 'SET_BANNER':
            return {
                ...state,
                banner: action.data
            }
        case 'CLEAR_BANNER':
            return {
                ...state,
                banner: null
            }
        case 'SET_NOTIFY':
            return {
                ...state,
                notify: action.data
            }
        case 'CLEAR_NOTIFY':
            return {
                ...state,
                notify: null
            }
        case 'SET_FLASH_NOTE':
            return {
                ...state,
                flashNote: action.data
            }
        case 'CLEAR_FLASH_NOTE':
            return {
                ...state,
                flashNote: null
            }
        case 'SET_DIMENSIONS':
            return {
                ...state,
                windowDimensions: getWindowDimensions()
            }
        case 'TOGGLE_PROCESSING':
            return {
                ...state,
                processing: action.state
            }
        case 'TOGGLE_PROCESSING_DASH':
            return {
                ...state,
                processingDash: action.state
            }
        case 'PROCESSING':
            return {
                ...state,
                processPercent: action.percent
            }
        case 'SET_ACTIVITIES':
            return {
                ...state,
                activities: action.activities
            }
        case 'TOGGLE_HEADER':
            return {
                ...state,
                showHeader: action.state
            }
        case 'TOGGLE_SETTINGS':
            const allowed_displays = ['account', 'security', 'appearance', null]
            if (allowed_displays.includes(action.display)) return {
                ...state,
                settings: action.display
            }
            return state
        case 'SET_ACTIVE_MENU':
            return {
                ...state,
                activeMenu: action.order
            }
        case 'TOGGLE_ASIDE':
            return {
                ...state,
                showAside: !action.aside
            }
        case 'SET_SHOW_BALANCE':
            localStorage.setItem('show_balance', action.state)
            return {
                ...state,
                showBalance: action.state
            }
        
        default:
            return state;
    }
}

export default reducer;